import script from "./VerticalScale.vue?vue&type=script&setup=true&lang=js"
export * from "./VerticalScale.vue?vue&type=script&setup=true&lang=js"

import "./VerticalScale.vue?vue&type=style&index=0&id=626ef487&scoped=true&lang=css"

import exportComponent from "/home/nodeapps/vitamins/edna/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626ef487"]])

export default __exports__